var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndopenMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,33.41a5,5,0,1,0,4.85,5A4.92,4.92,0,0,0,25,33.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.83,7.6c-4,0-7.53,1.5-11.11,4.45C25.81,4.59,21.21.39,14.13.39,6,.39,0,5.75,0,13.6A15.88,15.88,0,0,0,6.21,26.1l.25-.25A13.48,13.48,0,0,1,4,17.68C4,10.43,9,5.62,16.19,5.62c5.07,0,8.49,2.39,10.61,7.22L8.53,29q-4,3.52-7.89,6.42v9.16c3.86-4,7.47-7.4,10.81-10.3l17.25-15c1.19,7.8,5.2,11.61,11.21,11.61S50,27.29,50,19.89,45.78,7.6,38.83,7.6Zm1.41,19.2c-5.56,0-9.11-2.84-10.65-8.26L31,17.32c3.95-3.44,7.05-5.16,10.48-5.16,4.3,0,7.05,2.71,7.05,7.33,0,5-3.36,7.31-8.28,7.31Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndopenMark);
export default __webpack_public_path__ + "static/media/andopen-mark.7ae630b01ea7b88fc300d5c5f18f056c.svg";
export { ForwardRef as ReactComponent };